import React from "react";

const WelcomeSection = () => {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 w-full h-full">
        {/* Left - Background Image */}
        <div 
          className="relative min-h-[400px] md:min-h-[500px] lg:min-h-[600px] order-2 lg:order-1"
          style={{
            backgroundImage: 'url(/f1.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />

        {/* Right - White Overlay with Content */}
        <div className="relative bg-white px-6 md:px-8 lg:px-12 xl:px-16 py-12 md:py-16 lg:py-20 flex items-center order-1 lg:order-2">
          <div className="w-full space-y-6 md:space-y-8">
            {/* Title */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
              <span className="text-slate-800">Leading the Way in</span>
              <br />
              <span className="text-blue-600">Financial Excellence</span>
            </h2>

            {/* Main Text */}
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">
              Pawan Sut is a Non-Banking Financial Company (NBFC) committed to delivering responsible and accessible financial solutions to individuals and businesses across India. Built on a foundation of trust, discipline, and customer-centricity, Pawan Sut focuses on simplifying the borrowing experience through transparent processes and digital innovation.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6 md:gap-8 pt-4">
              <div className="flex flex-col">
                <div className="w-8 h-8 rounded-full border-2 border-black flex items-center justify-center mb-3">
                  <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="font-bold text-blue-600 text-base md:text-lg mb-1">Faster Approvals</p>
                <p className="text-sm md:text-base text-slate-800">Quick credit decisions</p>
              </div>

              <div className="flex flex-col">
                <div className="w-8 h-8 rounded-full border-2 border-black flex items-center justify-center mb-3">
                  <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="font-bold text-blue-600 text-base md:text-lg mb-1">Transparent Pricing</p>
                <p className="text-sm md:text-base text-slate-800">No hidden charges</p>
              </div>

              <div className="flex flex-col">
                <div className="w-8 h-8 rounded-full border-2 border-black flex items-center justify-center mb-3">
                  <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="font-bold text-blue-600 text-base md:text-lg mb-1">Flexible Repayment Options</p>
                <p className="text-sm md:text-base text-slate-800">EMIs that fits</p>
              </div>

              <div className="flex flex-col">
                <div className="w-8 h-8 rounded-full border-2 border-black flex items-center justify-center mb-3">
                  <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="font-bold text-blue-600 text-base md:text-lg mb-1">Dedicated Relationship Managers</p>
                <p className="text-sm md:text-base text-slate-800">Personalized loan support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
